export default __webpack_public_path__ + "static/hero_video_large-76db1b3375ae2ea7e76b97092757251b.mp4";